// src/components/BlogPost.jsx
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import blogPosts from '../data/blogPosts';

const BlogPost = () => {
    const { slug } = useParams();
    const post = blogPosts.find(p => p.slug === slug);

    if (!post) {
        return (
            <div className="container blog-not-found">
                <h2>Post not found</h2>
                <Link to="/">← Back to Home</Link>
            </div>
        );
    }

    return (
        <article className="blog-post-page">
            <div className="container">
                {/* Hero Image */}
                <img src={post.image} alt={post.title} className="blog-post-hero" />

                {/* Post Header */}
                <header className="blog-post-header">


                </header>

                {/* Styled Content — THIS IS THE MAGIC */}
                <div className={`blog-post-content ${post.customClass || ''}`}>
                    <h1>{post.title}</h1>
                    <div className="blog-meta">
                        <span className="blog-date">{post.date}</span>
                        <span className="blog-author">by {post.author}</span>
                    </div>
                    <div
                        className="blog-content-inner"
                        dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                </div>

                {/* Back Button */}
                <div className="blog-back">
                    <Link to="/" className="back-link">← Back to Home</Link>
                </div>
            </div>
        </article>
    );
};

export default BlogPost;